import React from "react";
import "./blogs.css";
import vignanBlogImg from "../../assets/blog_img/blog 2-vignan.png";
const VignanBlog = () => {
  return (
    <div className="vignan-blog">
      <div className="vignan-blog__header">
        <h2>Vignan Institute of Technology and Science</h2>
        <img
          src={vignanBlogImg}
          className="vignan-blog__img"
          alt="Vignan Blog"
        />
      </div>
      <div className="vignan-blog__intro">
        <a href="https://vignanits.ac.in" className="vignan-blog__link" aria-label="Vignan Institute of Technology and Science website">
          <h2 className="vignan-blog_header1">
            Vignan Institute of Technology and Science
          </h2>
        </a>
        <blockquote className="vignan-blog__quote">
          "In times of change, learners inherit the earth, while the learned
          find themselves beautifully equipped to deal with a world that no
          longer exists."
          <span className="vignan-blog__quote-author">– Eric Hoffer</span>
        </blockquote>
        <p className="vignan-blog__description">
          This quote underscores the urgency for educational institutions to
          adapt to the rapidly evolving digital era. Recognizing this need,
          Vignan's Foundation for Science, Technology & Research, a premier
          institution in Andhra Pradesh, partnered with Aspiron Technologies to
          redefine its operational and academic framework through a cutting-edge
          digital transformation initiative.
        </p>
        <section className="vignan-blog__section">
          <h2>A Legacy of Excellence, Evolving for the Future</h2>
          <p className="vignan-blog__section-description">
            The admissions team at Vignan faced numerous hurdles, including:
          </p>
          <ul className="vignan-blog__list">
            <li>Overwhelming piles of paper-based applications.</li>
            <li>Disorganized and scattered student data.</li>
            <li>
              The absence of a centralized system for managing admissions.
            </li>
            <li>
              Heavy reliance on Excel sheets for handling admissions processes.
            </li>
          </ul>
        </section>
        <section className="vignan-blog__section">
          <h2 className="vignan-blog__section-title">
            Aspiron to the Rescue: Our Approach
          </h2>
          <h4>1. Implementing a Unified Admissions CRM</h4>
          <p className="vignan-blog__subsection-description">
            We deployed our cutting-edge Student Admissions CRM, providing a
            centralized hub for managing admissions data and streamlining
            communications.
            <b>Impact:</b> A 65% reduction in response time to student inquiries
            and a 50% increase in efficient application handling.
          </p>
          <h4>2. Enabling Seamless Student Application Tracking</h4>
          <p className="vignan-blog__subsection-description">
            With our application tracking module, the admissions team gained
            full visibility into the status of every student application,
            ensuring no queries or documents were lost.
            <b>Impact:</b> Achieved 99% transparency in the application process
            and a 45% reduction in application processing time.
          </p>
          <h4>3. Personalized Admission Counseling Tools</h4>
          <p className="vignan-blog__subsection-description">
            By integrating student counseling modules, prospective students
            received clear guidance and personalized support throughout the
            admissions journey.
            <b>Impact:</b> A 35% increase in student satisfaction scores during
            the admission process.
          </p>
        </section>
        <section className="vignan-blog__testimonials">
          <h4>What They’re Saying</h4>
          <p className="vignan-blog__testimonials-quote">
            “Aspiron Technologies has completely transformed our admissions and
            campus management processes. From the seamless handling of
            applications to enhanced inter-departmental communication, their
            solutions have exceeded our expectations. It’s not just software;
            it’s a partnership that drives success.”
            <b>– Vignan's Foundation for Science, Technology & Research.</b>
          </p>
          <h4 className="vignan-blog__future-title">
            Embracing the Future with Aspiron
          </h4>
          <p className="vignan-blog__future-description">
            The journey of Vignan highlights the power of modern technology in
            addressing institutional challenges. By choosing Aspiron
            Technologies, they didn’t just adopt a tool; they embraced a
            comprehensive solution that redefined their operations.
          </p>
          <h4>Ready to Transform Your Institution?</h4>
          <p className="vignan-blog__cta-description">
            Join the growing community of institutions revolutionizing education
            management. Visit{" "}
            <a href="https://aspiron.in/" className="Aspiron_blog">
              www.aspiron.in
            </a>{" "}
            today for a personalized demo and explore how Aspiron Technologies
            can elevate your institution into the digital era.
          </p>
        </section>
        <hr className="vignan-blog__divider" />
        <div className="vignan-blog__social">
          {/* <hr className="vignan-footer-divider" /> */}
          <h3 className="vignan-blog_header3">Share on social media</h3>
          <div
            className="social-links"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
              padding: "10px",
              marginBottom: "10px",
              backgroundColor: "#F5F5F5",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <a
              href="https://www.facebook.com/sharer.php?u=https://www.aspiron.in/aspiron"
              className="fa fa-facebook"
              style={{
                fontSize: "20px",
                color: "#4267B2",
                textDecoration: "none",
                padding: "10px",
                borderRadius: "50%",
                backgroundColor: "#E9F0FF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s, transform 0.3s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#D6E2FF";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#E9F0FF";
                e.target.style.transform = "scale(1)";
              }}
               aria-label="Share on Facebook"
            ></a>
            <a
              href="https://twitter.com/intent/tweet?u=https://www.aspiron.in/aspiron"
              className="fa fa-twitter"
              style={{
                fontSize: "20px",
                color: "#1DA1F2",
                textDecoration: "none",
                padding: "10px",
                borderRadius: "50%",
                backgroundColor: "#E9F7FF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s, transform 0.3s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#D6EFFF";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#E9F7FF";
                e.target.style.transform = "scale(1)";
              }}
               aria-label="Share on Twitter"
            ></a>
            <a
              href="https://www.linkedin.com/feed/?linkOrigin=LI_BADGE&shareActive=true&shareUrl=https://www.aspiron.in/aspiron"
              className="fa fa-linkedin"
              style={{
                fontSize: "20px",
                color: "#0077B5",
                textDecoration: "none",
                padding: "10px",
                borderRadius: "50%",
                backgroundColor: "#EEF7FB",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s, transform 0.3s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#DCEFF7";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#EEF7FB";
                e.target.style.transform = "scale(1)";
              }}
               aria-label="Share on LinkedIn"
            ></a>
            <a
              href="https://www.youtube.com/u=https://www.aspiron.in/aspiron"
              className="fa fa-youtube"
              style={{
                fontSize: "20px",
                color: "#FF0000",
                textDecoration: "none",
                padding: "10px",
                borderRadius: "50%",
                backgroundColor: "#FDE7E7",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s, transform 0.3s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#FBD4D4";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#FDE7E7";
                e.target.style.transform = "scale(1)";
              }}
               aria-label="Share on YouTube"
            ></a>
            <a
              href="https://api.whatsapp.com/send?u=https://www.aspiron.in/aspiron"
              className="fa fa-whatsapp"
              style={{
                fontSize: "20px",
                color: "#25D366",
                textDecoration: "none",
                padding: "10px",
                borderRadius: "50%",
                backgroundColor: "#E9F9EC",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s, transform 0.3s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#D6F3DF";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#E9F9EC";
                e.target.style.transform = "scale(1)";
              }}
               aria-label="Share on Whatsapp"
            ></a>
          </div>
        </div>
        <div>
          <h3>About the Author</h3>
          <div>
            <p className="vignan-blog__author-bio">
              <b>
                <i>Harsha</i>
              </b>{" "}
              is the accomplished social Media Marketing Associate at Aspiron,
              bringing a wealth of expertise in driving business growth and
              implementing innovative marketing strategies. With a proven track
              record in competitive markets, Harsha leverages visionary
              leadership, exceptional analytical skills, and outstanding
              communication abilities to lead Aspiron toward success.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VignanBlog;